import styled from 'styled-components';
import { StyledSelect } from '../select.style';

export const SelectWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;

  ${props => props.theme.media.largeScreenUp} {
    max-width: 600px;
  }
`;

export const SelectHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
`;

export const SelectLabelText = styled.span`
  font-family: ${props => props.theme.fontFamilies.main.medium};
  font-size: 16px;
  color: ${props => props.theme.colors.content.primary};
`;

export const ClearSelectionButton = styled.button`
  appearance: none;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  font-family: ${props => props.theme.fontFamilies.main.medium};
  font-size: 14px;
  color: ${props => props.theme.colors.content.accent1};
  text-decoration: underline;
  white-space: nowrap;

  &:disabled {
    cursor: not-allowed;
    color: ${props => props.theme.colors.content.secondary};
    text-decoration: none;
  }
`;

export const SelectWithoutVisibleLabel = styled(StyledSelect)`
  max-width: none;

  /* Keep the native Select label for a11y / required asterisk; header above is visual. */
  > label:first-of-type {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
`;
